import { render, staticRenderFns } from "./PagamentoAlert.vue?vue&type=template&id=51c1a9d8&"
import script from "./PagamentoAlert.vue?vue&type=script&lang=js&"
export * from "./PagamentoAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports